export default __webpack_public_path__ + "static/media/image3.11507ba8.webp";